import { CustomApplicationActions } from "@MasterBluePrint/Store/CustomApplicationState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

interface Parameter {
    keptUnverifiedAddress: boolean;
}

type HandlerType = Handler<Parameter, DispatchProp<CustomApplicationActions>>;

export const DispatchSetKeptUnverifiedAddress: HandlerType = props => {
    props.dispatch({
        type: "Components/CustomCheckoutShipping/SetKeptUnverifiedAddress",
        keptUnverifiedAddress: props.parameter.keptUnverifiedAddress,
    });
};

export const chain = [DispatchSetKeptUnverifiedAddress];

const setKeptUnverifiedAddress = createHandlerChainRunner(chain, "SetKeptUnverifiedAddress");
export default setKeptUnverifiedAddress;
